export default "__VITE_ASSET__DJN7DYty__"